// @ts-ignore
import store from '../../../../store';
import {GameEventContainer} from './active_data/base/static_config_data/GameEventContainer';
import {IJsonPatch} from './active_data/base/static_config_data/JsonPatch';
import {utils} from 'pixi.js';
import {FieldData} from './active_data/FieldData';

export class ActiveData
{
    static root: FieldData;

    static eventsPool: Array<GameEventContainer<any>> = [];
    static eventsAfterPatch: boolean = true;

    static hideEvents(): void {
        ActiveData.eventsAfterPatch = false;
    }

    static applyJsonPatchArray(patchArray: Array<IJsonPatch>): void {
        ActiveData.root.applyJsonPatchArray(patchArray);
    }

    static showEvents(): void {
        ActiveData.eventsAfterPatch = true;
    }

    static createClasses(): void {
        let field = store.getters.getGameField;
        ActiveData.root = new FieldData(field);
    }

    static processServerResponse(obj: any) {
        if (obj.op != null) {
            //console.log('before json patch');
            ActiveData.root.applyJsonPatchArray(obj.op);
            //console.log('after json patch');
        }
    }

    static addEventToPool<T>(dispatcher: utils.EventEmitter, event: string, data?: T): void {
        let eventContainer: GameEventContainer<T> = new GameEventContainer<T>(dispatcher, event, data);
        ActiveData.eventsPool.push(eventContainer);
    }

    static dispatchEventsPool(): void {
        if (!ActiveData.eventsAfterPatch) {
            ActiveData.eventsPool = [];
            return;
        }
        let eventContainer: GameEventContainer<any>;
        while (ActiveData.eventsPool.length > 0) {
            eventContainer = ActiveData.eventsPool.shift() as GameEventContainer<any>;
            eventContainer.dispatchEvent();
        }
    }
}
